import { ROUTES } from '@/types/common';
import Link from 'next/link';

interface Props {
  iconImgSrc: string;
  name: string;
  onClick: () => void;
}

const DepartmentButton = (props: Props) => {
  return (
    <Link href={`${ROUTES.DISEASE_ENCYCLOPEDIA.SEARCH.path}?keyword=${props.name}`}>
      <a className='flex aspect-square flex-col items-center justify-center gap-[12px] overflow-visible'>
        <div className='flex h-full w-full items-center justify-center'>
          <div
            className='flex items-center justify-center rounded-[18px] bg-gray-20 sm:rounded-[25px] '
            style={{ padding: '20%' }}
          >
            <img src={props.iconImgSrc} alt={props.name} className='h-full w-full object-contain' />
          </div>
        </div>
        <h3 className='typography-ui-13m lg:typography-ui-15m text-clip whitespace-nowrap text-gray-700'>
          {props.name}
        </h3>
      </a>
    </Link>
  );
};

export default DepartmentButton;
